module.exports = __webpack_public_path__ + "static/media/trans-Tenant-Selection.d43e170f.svg";